export default "/_next/static/images/product-apps-legacy-8bf54484a6d1a91e5cb4a4a07029f3fb.svg";